import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const VirtualTour = ({ id }) => {
  const [virtualTourList, setVirtualTourList] = useState([]);

  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Facility/GetFacilityVirtualTour?facilityID=${id}`
      );
      if (list && list.length > 0) {
        setVirtualTourList(list);
      } else {
        setVirtualTourList([]);
      }
    } catch (error) {
      setVirtualTourList([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (virtualTourList?.length) {
      const $slider = $(".VirtualTour-slider");

      if ($slider.length) {
        $slider.owlCarousel({
          autoplay: true,
          smartSpeed: 100,
          margin: 30,
          loop: true,
          autoplayHoverPause: true,
          dots: false,
          arrows: false,
          nav: false,
          center: true,
          items: 4,
          stagePadding: 60,
          navText: [
            '<i class="ti-arrow-left"></i>',
            '<i class="ti-arrow-right"></i>',
          ],
          responsive: {
            0: { items: 1, stagePadding: 5 },
            575: { items: 1, stagePadding: 5 },
            767: { items: 2 },
            992: { items: 2 },
            1200: { items: 4 },
          },
        });

        // Delegated click handler for both original and cloned items
        $slider.on("click", ".wpo-team-img", function () {
          const data = $(this).attr("data-tour");
          if (data) {
            const tour = JSON.parse(decodeURIComponent(data));
            if (tour.kuulaLink) {
              window.open(tour.kuulaLink, "_blank");
            }
          }
        });
      }

      return () => {
        $slider.trigger("destroy.owl.carousel");
        $slider.off("click", ".wpo-team-img");
      };
    }
  }, [JSON.stringify(virtualTourList)]);

  if (!virtualTourList || virtualTourList.length === 0) return null;

  return (
    <section className="wpo-team-section pb-0 section-padding">
      <div className="wpo-section-title">
        <h4>Virtual Tour</h4>
        <div className="shape-2 wow fadeInUp custom-animation">
          <img src="/assets/images/Wedding/shape6.png" alt="Section Shape" />
        </div>
      </div>
      <div className="wpo-team-wrap">
        <div className="row">
          <div className="VirtualTour-slider owl-carousel">
            {virtualTourList.map((tour, index) => {
              const encodedImagePath = tour.oldImagePath
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29")
                .replace(/ /g, "%20");
              const fullImageURL = `${ImageURL}${encodedImagePath}`;
              return (
                <div
                  className="col-lg-3 col-md-6 col-sm-6 col-12"
                  key={tour.virtualMappingID}
                >
                  <div
                    className="wpo-team-item wow fadeInUp"
                    data-wow-duration={`${1000 + index * 200}ms`}
                  >
                    <div
                      className="wpo-team-img"
                      data-tour={encodeURIComponent(JSON.stringify(tour))}
                      style={{
                        backgroundImage: `url(${fullImageURL})`,
                        backgroundSize: "cover",
                        cursor: "pointer",
                      }}
                    ></div>
                    <div className="wpo-team-text wpo-Service-text-Dum">
                      <h4>{tour.virutalMappingTitle}</h4>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VirtualTour;
